import { EventTrackingValue } from '../../../../team-apis/core/event-tracking';
import { MultiClickShapeToolHelper } from '../shared/tool-helpers/multi-click-shape-tool-helper';

export class SliderRectangleToolHelper extends MultiClickShapeToolHelper {
  protected override removeLastPlacedSubpoint(
    eventTrackingValue: EventTrackingValue,
  ) {
    const points = this.getPointsStore().state();

    if (points.length === 5) {
      this.getPointsStore().setUsing((currentPoints) =>
        currentPoints.slice(0, 4),
      );
      this.shellConnector.trackEvent({
        id: 'undo_subpoint',
        bucket: 'annotation',
        ...eventTrackingValue,
      });
    } else {
      this.cancel(eventTrackingValue);
    }
  }
}
